import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    user: '',
    jwtToken: '',
    profile: '',
    error: '',
    email: '',
    validatedEmail: false,
}

const verifyGoogleLoginSuccess=(state, action)=>{
    return {
        ...state,
        user: action.user,
        jwtToken: action.jwtToken,
        profile: action.profile,
        error: ''
    }
}

const verifyGoogleLoginError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}


const twofaValidateEmailSuccess=(state,action)=>{
    return {
        ...state,
        email: action.email,
        validatedEmail: true,
        error: ''
    }
}

const twofaValidateEmailError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const twofaLoginSuccess=(state,action)=>{
    return {
        ...state,
        user: action.user,
        jwtToken: action.jwtToken,
        profile: action.profile,
        error: ''
    }
}

const twofaLoginError=(state,action)=>{
    return {
        ...state,
        user: '',
        jwtToken: '',
        error: action.error
    }
}

const logout=(state)=>{
    return {
        ...state,
        user: '',
        jwtToken: '',
        profile: '',
        validatedEmail: false,
        email: ''
    }
}

export default reduce(initialState,{
    [actionTypes.VERIFY_GOOGLE_LOGIN_SUCCESS]: verifyGoogleLoginSuccess,
    [actionTypes.VERIFY_GOOGLE_LOGIN_ERROR]: verifyGoogleLoginError,
    [actionTypes.TWOFA_VALIDATE_EMAIL_SUCCESS]: twofaValidateEmailSuccess, 
    [actionTypes.TWOFA_VALIDATE_EMAIL_ERROR]: twofaValidateEmailError,
    [actionTypes.TWOFA_LOGIN_TAC_SUCCESS]: twofaLoginSuccess,
    [actionTypes.TWOFA_LOGIN_TAC_ERROR]: twofaLoginError,
    [actionTypes.LOGOUT]: logout
});


// WEBPACK FOOTER //
// ./src/redux/auth/reducer.js